<!-- 購入チケットの変更の注意書き -->
<template>
  <div class="purcahsed-change-caution">
    同一の乗車日における変更は、ご購入済みの特急券の発車時刻が過ぎるまでの間で、変更後の列車に空席がある限り、何度でも可能です。<br />
    ただし、区間変更はできませんのでご了承ください。<br />
    <p v-if="isChangeableBoardingDate">
      また、異なる乗車日への変更は、1回のみ可能です。
    </p>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "MFITTPurchasedTicketChangeCaution",
  setup() {
    const store = useStore();
    const isChangeableBoardingDate = computed(
      () =>
        store.getters["MFITT/myLimitedExpressTicket"] == null ||
        store.getters["MFITT/myLimitedExpressTicket"]
          .changeable_boarding_date == null ||
        store.getters["MFITT/myLimitedExpressTicket"]
          .changeable_boarding_date == true
    );
    return {
      isChangeableBoardingDate,
    };
  },
};
</script>
<style lang="scss">
.purcahsed-change-caution {
  border: 1px solid #f4ed9b;
  border-radius: 10px;
  background-color: #fffabe;
  font-size: 13px;
  line-height: 1.5;
  padding: 15px 13px;
  margin: 30px 13px;
}
</style>
